import { el, clear } from "./dom.js";
import { MAG } from "./magazine/kit.js";
import { navigate } from "../main.js";
import { getCredits, personRoute } from "../api/people.js";

// The "People" row on a detail screen (design_documents/people.md): the key
// credits of an item as chips — "Peter Jackson · Director ›" — each opening
// that person's page. Fills itself in asynchronously; stays empty (hidden) when
// the source knows nobody or is unreachable.

// peopleRow's media token → the app's media_type.
const MEDIA_OF = { game: "videogame", movie: "movie", tv: "tv", book: "book", anime: "anime" };

export function peopleRow(mediaType, externalId) {
	const chips = el("div", { style: { display: "flex", gap: "7px", flexWrap: "wrap" } });
	const wrap = el(
		"div",
		{ hidden: true, style: { padding: "10px 16px 0" } },
		el("div", {
			style: {
				fontFamily: "'Archivo', sans-serif", fontWeight: "900", fontSize: "8.5px",
				letterSpacing: ".1em", textTransform: "uppercase", color: MAG.dim, marginBottom: "6px",
			},
		}, "People"),
		chips,
	);
	if (!externalId) return wrap;
	getCredits(mediaType, externalId)
		.then((credits) => {
			clear(chips);
			for (const c of credits.slice(0, 8)) {
				chips.append(
					el("button", {
						type: "button",
						onclick: () => navigate(personRoute(c.source, c.person_id, MEDIA_OF[mediaType] ?? mediaType)),
						style: {
							fontFamily: "'Archivo', sans-serif", fontWeight: "800", fontSize: "11px",
							borderRadius: "999px", padding: "7px 12px", cursor: "pointer",
							color: MAG.ink, background: "rgba(255,255,255,.07)", border: `1px solid ${MAG.line}`,
						},
					}, `${c.name} · ${c.roles.slice(0, 2).join(", ").toLowerCase()} ›`),
				);
			}
			wrap.hidden = credits.length === 0;
		})
		.catch(() => {
			// No credits source reachable — the row just stays hidden.
		});
	return wrap;
}
